<template>
    <div class="SettingsPage">
        <DashboardSectionHeader title="Settings"/>

        <AccountForm/>
        <CompanyForm v-if="user.role === 'owner'" :company="company"/>
        <ProfileForm/>
        <TicketCounterForm v-if="user.role === 'owner'" :company="company"/>
        <TimeRoundingForm :company="company"/>

        <SubscriptionForm v-if="user.role === 'owner'"/>

        <DashboardEditSection title="Notifications" v-if="user.role !== 'admin'">
            <h2>Email Notifications</h2>
            <div class="toggleRow">
                <h4>When driver submits a new ticket</h4>
                <FormToggle v-model="newTicketSubmitted" @input="handleUpdateSettings"/>
            </div>
            <div class="toggleRow">
                <h4>Upcoming payments</h4>
                <FormToggle v-model="upcomingPayments" @input="handleUpdateSettings"/>
            </div>
        </DashboardEditSection>
    </div>
</template>


<script>
import * as api from '@/api';
import { mapState, mapGetters } from 'vuex';
import DashboardSectionHeader from '@/components/DashboardSectionHeader';
import DashboardEditSection from '@/components/DashboardEditSection';
import AccountForm from './components/AccountForm';
import ProfileForm from './components/ProfileForm';
import CompanyForm from './components/CompanyForm';
import SubscriptionForm from './components/SubscriptionForm';
import TicketCounterForm from './components/TicketCounterForm';
import TimeRoundingForm from './components/TimeRoundingForm';

export default {
    name: 'SettingsPage',

    components: {
        DashboardSectionHeader,
        DashboardEditSection,
        SubscriptionForm,
        AccountForm,
        ProfileForm,
        CompanyForm,
        TicketCounterForm,
        TimeRoundingForm,
    },

    data: () => ({
        newTicketSubmitted: false,
        upcomingPayments: false,
    }),

    computed: {
        ...mapState('auth', ['user']),
        ...mapGetters('auth', ['company']),
    },

    mounted() {
        this.newTicketSubmitted = this.user.settings?.notifications?.newTicketSubmitted;
        this.upcomingPayments = this.user.settings?.notifications?.upcomingPayments;
    },

    methods: {
        async handleUpdateSettings() {
            const settings = {
                ...this.user.settings,
                notifications: {
                    newTicketSubmitted: this.newTicketSubmitted,
                    upcomingPayments: this.upcomingPayments,
                },
            };

            const res = await api.updateUserSettings(this.user.id, settings);

            if (res.error) {
                return this.$awn.alert('Failed to update notification settings!');
            }

            await this.$store.dispatch('auth/refreshUser');
            this.newTicketSubmitted = this.user.settings?.notifications?.newTicketSubmitted;
            this.upcomingPayments = this.user.settings?.notifications?.upcomingPayments;
        },
    },
};
</script>


<style lang="scss" scoped>
.SettingsPage {
    .toggleRow {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:not(:last-child) {
            margin-bottom: 15px;
        }
    }
}
</style>
